/**
 * The all-time leaderboard ("High Rollers") is now rendered as a 3D backlit sign
 * in the scene (`scene/HighRollersSign.tsx`) — the old DOM marquee div is retired.
 *
 * What remains here is a tiny VISUALLY-HIDDEN a11y mirror of the standings so the
 * leaderboard is still announced to screen readers (the 3D troika text is not in
 * the accessibility tree). It is bound to the same `leaderboard` store slice.
 */

import { useGameStore } from '../state/store';
import { formatCents } from '../util/format';

export function LeaderboardA11y() {
  const leaderboard = useGameStore((s) => s.server.leaderboard);

  return (
    <div className="sr-only" aria-label="High Rollers leaderboard">
      <h2>High Rollers</h2>
      <ol>
        {leaderboard.length === 0 && <li>No standings yet</li>}
        {leaderboard.map((e, i) => (
          <li key={`${e.name}-${i}`}>
            {i + 1}. {e.name} — {formatCents(e.balanceCents)}
          </li>
        ))}
      </ol>
    </div>
  );
}
